<div *transloco="let t; read: 'search-input'"
  [class.has-error]="formControlRef && formControlRef.invalid && !focused && formControlRef.touched">
  <div class="input-label-container">
    <div class="label-hint">
      <label [for]="searchInputLabelId"
        aria-hidden="true">
        {{ label }}
      </label>

      @if (hint) {
        <div class="hint">{{ hint }}</div>
      }
    </div>

    @if (formControlRef?.value) {
      <button mat-stroked-button
        class="mat-default mat-button-small"
        [attr.aria-label]="t('aria_clear', { name: label })"
        (click)="clearSelected()">{{ t('clear') }}
      </button>
    }
  </div>

  <div class="search-input"
    (click)="onInputClick()"
    (keydown)="onInputKeydown($event)">
    <div class="search-input-wrapper mat-form-field"
      [ngClass]="{ 'input-focused': focused, 'cdk-keyboard-focused': cdkKeyboardFocused }">
      @if (!inputEl.value) {
        <div class="selected-option">
          {{ formControlRef?.value && formControlRef?.value[labelKey] }}
        </div>
      }

      <div class="input-wrapper"
        [class.input-hidden]="!inputEl.value">
        <input #inputEl
          type="text"
          autocomplete="off"
          [id]="searchInputLabelId"
          [placeholder]="formControlRef?.value ? '' : placeholder"
          [attr.aria-describedby]="hint ? hint : null"
          (keyup)="onSearch(inputEl.value)"
          (focus)="inputFocused($event)"/>
      </div>
    </div>

    @if (focused) {
      <div #availableOptionsContainer
        class="available-options mat-form-field">
        @if (!loading) {
          @for (option of availableOptions; track option.id; let i = $index) {
            <div class="single-option"
              role="option"
              [class.option-marked]="i === markedOptionIndex"
              (mouseenter)="markedOptionIndex = i"
              (click)="selectOption($event, option)">
              {{ option[labelKey] }}
            </div>
          }
        }

        @if (loading) {
          <div class="empty-placeholder">
            {{ t('loading_results') }}
          </div>
        }

        @if (!loading && !availableOptions.length) {
          <div class="empty-placeholder">
            {{ (!loaded && dynamic) ? t('type_to_search') : t('no_results_found') }}
          </div>
        }
      </div>
    }
  </div>
</div>
